<section style="text-align: center">
    <h1>Unauthorized Access</h1>

    <p>It would appear that you do not have access to view this page or complete this action.</p>
    <p>If you have recently changed roles, try signing out and signing in again to see if that fixes the issue.</p>
    <p>Otherwise use the sidebar menu to navigate a different page, or simply go back.</p>
</section>
